import { render, staticRenderFns } from "./grid-main-player.vue?vue&type=template&id=a2e1d9a6"
import script from "./grid-main-player.vue?vue&type=script&lang=js"
export * from "./grid-main-player.vue?vue&type=script&lang=js"
import style0 from "./grid-main-player.vue?vue&type=style&index=0&id=a2e1d9a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports